// extracted by mini-css-extract-plugin
export default {"inputWrap":"mpC1Qg6QVr63toFBolgC","scopesSelect":"RDv2Hrj_vGtrkg9SM1Yi"};